import React, { useState } from "react"
import { cn } from "lib/utils" 


export default function CollapsiblePanel({ PanelComp, children }:{ PanelComp:any, children:React.ReactNode}){

  const [ showLoader, setShowLoader ] = useState(true) 

  return (
    <div className="w-full flex gap-8">
      <div 
        className={cn(
          "flex flex-col gap-2",
          showLoader ? "w-3/12" : "w-[3rem]"
        )}
      >
        <PanelComp />
      </div>  
    
      <div className={cn("px-8", showLoader ? "w-9/12" : "w-full")}>
        { children }
      </div>
    </div>
  )
}